import { render, staticRenderFns } from "./Shirt.vue?vue&type=template&id=31cee932&"
import script from "./Shirt.vue?vue&type=script&lang=js&"
export * from "./Shirt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports